import { ProductCart, DeliveryMethod, Entity, LocationDetails } from './';

export interface CartItem extends Entity {
  location: LocationDetails;
  products: ProductCart[];
  delivery: DeliveryMethod[];
  total?: number; // Only for Frontend
  // id: Only for Frontend
}
